import Marionette from "backbone.marionette";

import ProfileTpl from "views/profile/profileView.ejs";
import CSS from "views/profile/profile.css";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({    
    template: ProfileTpl,
    render: function() {
        this.$el.html(ProfileTpl(S.userInfo));
    },
    events: {
        "submit #userProfile": "submit",
        "click #back": "go_back"
    },
    submit: function(ev) {
        var formData = {};
        _.each(ev.target.elements, function(element) {
            if (element.nodeName === "BUTTON")
                return;
            formData[$(element).attr("id")] = $(element).val();
        });

        S.userInfo.save(formData, {
            beforeSend: T.useToken,
            contentType: "application/x-www-form-urlencoded",
            success: function() {
                S.mApp.trigger("notify:success", { message: S.userInfo.attributes.lang.INSERT_OK });
                S.mApp.trigger("update:profile");
            },
            error: function() {
                S.mApp.trigger("notify:error", { message: S.userInfo.attributes.lang.INSERT_ERROR });
            }
        });

        return false;
    },
    go_back: function(ev) {

        parent.history.back();
    }

});


//////////////////
// WEBPACK FOOTER
// ./app/views/profile/profileView.js
// module id = 204
// module chunks = 0